import React from 'react';

export interface ReadershipStatisticProps {
  statistic: string;
  cadence: string;
  definition: string;
}

const ReadershipStatistic = ({
  statistic,
  cadence,
  definition,
}: ReadershipStatisticProps): JSX.Element => (
  <div className="border-0 border-l-[3px] border-solid border-grayscale-beige pl-16">
    <dt className="font-suisse-works text-subheadline-sm text-grayscale-charcoal sm:text-headline-lg">
      <span className="mb-8 text-headline-lg leading-none text-primary-magenta sm:text-[80px]">
        {statistic}
      </span>
      {cadence}
    </dt>
    <dd className="m-0 max-w-[150px] font-suisse-intl text-body-lg font-light text-black sm:max-w-full">
      {definition}
    </dd>
  </div>
);

export default ReadershipStatistic;
